import { fleetRecordPath } from '../fleet/fleet-tabs';

/** A truck's own page gives each tab its own route, `/fleet/trucks/:id/<tab>` (`recordTabRoutes`). */
export const TRUCK_TABS = ['details', 'documents', 'ownership', 'history'] as const;
export type TruckTab = (typeof TRUCK_TABS)[number];

export const TRUCK_TAB_LABELS: Record<TruckTab, string> = { details: 'Details', documents: 'Documents', ownership: 'Ownership', history: 'History' };

export function truckTabPath(id: string, tab: TruckTab): string {
  return `${fleetRecordPath('trucks', id)}/${tab}`;
}
